<template>
	<div v-if="game" id="credits" class="credits">
		<div class="header">
			<div class="ourteam-nexon-logo">
				<img src="@/images/corporate/about/logo.png" />
			</div>
			<div class="ourteam-logo">
				<img src="@/images/ourteam/logo.png" />
			</div>
			<div class="game-logo">
				<div v-if="game.largeLogo" :style="{ backgroundImage: `url(${cdnHost}${game.largeLogo})` }"></div>
				<div v-else :style="{ backgroundImage: `url(${staticHost}images/nexon-logo.png)` }"></div>
			</div>
		</div>
		<div class="credits-container">
			<div class="game-list-container">
				<div class="game-list">
					<div v-for="menuGame in employeeRecList" :key="menuGame.id" class="game" @click="navToGame(menuGame)">
						<div class="game-logo">
							<div v-if="menuGame.listIcon" :style="{ backgroundImage: `url(${cdnHost}${menuGame.listIcon})` }"></div>
							<div v-else :style="{ backgroundImage: `url(${staticHost}images/nexon.ico)` }"></div>
						</div>
						<div class="game-name">{{ getLocaleString(menuGame.title) }}</div>
					</div>
				</div>
			</div>
			<div class="team-list-container">
				<div class="team-list">
					<div v-for="(team, index) in allDepartments" :key="index" class="team">
						<template v-if="team">
							<div class="team-name">{{ team.name }}</div>
							<div :class="`team-member-list count-${team.employees.length}`">
								<div v-for="(teamMember, $index) in team.employees" :key="$index" class="team-member">
									{{ teamMember }}
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="btn-back" @click="navToMain()">
					<div class="back-icon"></div>
					{{ $t('main.ourteam.back') }}
				</div>
			</div>
			<div class="empty"></div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getLocaleString } from '@/plugins/helpers';

export default {
	name: 'Credits',
	components: {},
	data() {
		return {};
	},
	computed: {
		...mapState(['employeeRecList', 'generalDepartmentsList']),
		url_game_title() {
			return this.$route.params.title;
		},
		game() {
			return this.employeeRecList.find((game) => game.name === this.url_game_title);
		},
		language() {
			return this.$i18n.locale;
		},
		matchedGeneralDepartments() {
			return (
				this.game &&
				this.game.generalDepartments &&
				this.game.generalDepartments.map((departmentId) =>
					this.generalDepartmentsList.find((generalDepartment) => generalDepartment.id === departmentId)
				)
			);
		},
		allDepartments() {
			return (this.game.Children || []).concat(this.matchedGeneralDepartments || []);
		},
	},
	mounted() {},
	async created() {
		this.getEmployeeRecList();
		this.getGeneralDepartmentsList();
	},
	methods: {
		...mapActions(['getEmployeeRecList', 'getGeneralDepartmentsList']),
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
		navToMain() {
			this.$router.push({
				name: 'ourteam',
			});
		},
		navToGame(game) {
			if (game.id === this.game.id) return;
			this.$router.push({
				name: 'credits',
				params: {
					title: game.name,
				},
			});
		},
	},
};
</script>

<style lang="less">
#credits {
	padding: 56px 0 10px;
	line-height: 1.33;
	font-family: Roboto;
	background-image: radial-gradient(circle at top, rgba(10, 160, 210, 50%), #151517 235px);
	.header {
		margin: 0 40px 0;
		border-bottom: 2px solid rgba(255, 255, 255, 0.5);
		.ourteam-nexon-logo {
			margin-top: 25px;
			img {
				width: 225px;
				display: block;
				margin: auto auto;
			}
		}
		.ourteam-logo {
			margin-top: 25px;
			img {
				width: 166px;
				display: block;
				margin: auto auto;
			}
		}
		.game-logo {
			height: 100px;
			width: 170px;
			margin: auto auto;
			display: block;
			margin-top: 10px;
			div {
				height: 100%;
				width: 100%;
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center;
			}
		}
	}
	.game-list-container,
	.empty {
		display: none;
	}
	.team-list {
		margin: 0 40px;
		border-bottom: 2px solid rgba(255, 255, 255, 0.5);
		.team {
			padding: 20px;
			&:not(:last-child) {
				border-bottom: 1px solid rgba(255, 255, 255, 0.25);
			}
			.team-name {
				text-align: center;
				font-size: 18px;
				padding: 0 20px;
				color: #fff;
				text-transform: uppercase;
			}
			.team-member-list {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				font-size: 14px;
				text-align: center;
				color: rgba(255, 255, 255, 0.502);
				&.count-1 {
					display: block;
				}
				.team-member {
					transition: 0.2s;
					margin-top: 20px;
					flex: 0 0 50%;
				}
			}
		}
	}
	.btn-back {
		margin: 50px auto;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(255, 255, 255, 0.502);
		width: fit-content;
		padding: 10px 20px;
		border-radius: 25px;
		cursor: pointer;
		text-transform: uppercase;
		font-weight: bold;
		color: rgba(255, 255, 255, 0.502);
		height: 35px;
		transition: 0.2s;
		&:hover {
			color: #fff;
			border-color: #fff;
			.back-icon {
				opacity: 1;
			}
		}
		.back-icon {
			background: url('~@/images/ourteam/back.png') no-repeat center;
			height: 10px;
			margin: 0 5px 1px 0;
			width: 8px;
			opacity: 0.5;
			transition: 0.2s;
		}
	}
}

@media (min-width: 768px) {
	div#credits {
		background-image: radial-gradient(circle at top, rgba(10, 160, 210, 50%), #151517 325px);
		.header {
			.ourteam-nexon-logo {
				margin-top: 50px;
				img {
					width: 450px;
				}
			}
			.ourteam-logo {
				margin-top: 50px;
				img {
					width: 275px;
				}
			}
		}
		.team-list {
			.team {
				.team-member-list {
					&.count-2 {
						display: block;
						.team-member {
							display: inline-block;
							width: calc(100% / 2);
						}
					}
					.team-member {
						flex: 0 0 33%;
					}
				}
			}
		}
	}
}

@media (min-width: 1024px) {
	div#credits {
		background-image: radial-gradient(circle at top, rgba(10, 160, 210, 50%), #151517 375px);
		margin: 0 20px;
		.header {
			max-width: 960px;
			margin: 0 auto;
		}
		.team-list {
			max-width: 960px;
			margin: 0 auto;
			.team {
				.team-member-list {
					&.count-3 {
						display: block;
						.team-member {
							display: inline-block;
							width: calc(100% / 3);
						}
					}
					.team-member {
						flex: 0 0 25%;
					}
				}
			}
		}
	}
}

@media (min-width: 1800px) {
	div#credits {
		margin: 0;
		.credits-container {
			display: flex;
			justify-content: center;
			.game-list-container {
				display: flex;
				justify-content: center;
				flex: 0 1 33%;
				.game-list {
					width: 220px;
					height: fit-content;
					border: 2px solid rgba(255, 255, 255, 0.25);
					border-radius: 10px;
					position: sticky;
					top: 76px;
					padding: 15px 10px;
					.game {
						display: flex;
						align-items: center;
						height: 60px;
						cursor: pointer;
						border: 1px solid transparent;
						border-radius: 5px;
						padding-right: 5px;
						.game-logo {
							min-width: 60px;
							height: 60px;
							display: flex;
							align-items: center;
							justify-content: center;
							div {
								width: 45px;
								height: 45px;
								background-repeat: no-repeat;
								background-size: contain;
							}
						}
						.game-name {
							font-size: 12px;
							color: #fff;
							font-weight: bold;
							line-height: 1.5;
						}
						&:hover {
							border: 1px solid rgba(0, 119, 255);
						}
					}
				}
			}
			.team-list-container {
				flex: 0 0 960px;
			}
			.empty {
				flex: 0 1 33%;
				display: block;
			}
		}
	}
}
</style>
